import { getProgramEditionId } from "#core/components/content-library/assign-cart/assign-cart-store";
import { Edition } from "@carnegie-learning/cure-types";
import { createSelector } from "@ngrx/store";
import * as fromFeature from "../reducers";
import * as fromActiveEditions from "../reducers/active-editions.reducer";

export const getActiveEditionsState = createSelector(
    fromFeature.getCoursesModuleState,
    (state: fromFeature.CoursesState) => state.activeEditions
);

export const getActiveEditionsEntities = createSelector(
    getActiveEditionsState,
    fromActiveEditions.getActiveEditionsEntities
);

export const getAllActiveEditions = createSelector(
    getActiveEditionsEntities,
    (entities) => {
        return Array.from(entities.values());
    }
);

export const getActiveEditionsLoading = createSelector(
    getActiveEditionsState,
    fromActiveEditions.getActiveEditionsLoading
);

export const getActiveEditionsLoaded = createSelector(
    getActiveEditionsState,
    fromActiveEditions.getActiveEditionsLoaded
);

export const getSelectedEditionGlobalResources = createSelector(
    getAllActiveEditions,
    getProgramEditionId,
    (editions: Edition[], editionId: string): string[] => {
        const globalResources = editions.find(
            (e) => e.editionId === editionId
        )?.globalResources;
        return globalResources ? globalResources : [];
    }
);
